export default {
  namespaced: true,
  state: {
    isPayerChatOpen: false,
    unreadMessagesCount: 0,
  },
  mutations: {
    SET_PAYER_CHAT_OPEN(state, isOpen) {
      state.isPayerChatOpen = isOpen;
    },
    SET_UNREAD_OPERATOR_MESSAGES_COUNT(state, unreadMessagesCount) {
      state.unreadMessagesCount = unreadMessagesCount;
    }
  },
  actions: {
    togglePayerChat({ commit, state }) {
      commit("SET_PAYER_CHAT_OPEN", !state.isPayerChatOpen);
    },
    openPayerChatModal({ commit }) {
      commit("SET_PAYER_CHAT_OPEN", true);
    },
    closePayerChatModal({ commit }) {
      commit("SET_PAYER_CHAT_OPEN", false);
    },
  },
};
